const teacher = {
    state: {
        questionList: [],
        missionObj: {},
        groupCase: {}
    },
    mutations: {
        setQuestionList(state, list) {
            state.questionList.push(...list);
        },
        setMisssionItem(state, obj) {
            state.missionObj = obj;
        },
        setGroupCase(state, obj) {
            state.groupCase = obj;
        }

    }
};

export default teacher;


// WEBPACK FOOTER //
// ./src/store/modules/teacher.js